import styled from "styled-components";

const ButtonWrapper = styled.button`
  border: 1px solid #b5cadc;
  border-radius: 4px;
  background: #e7edf2;
  width: 30px;
  height: 30px;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IconButton = ({ icon }) => {
  return <ButtonWrapper>{icon}</ButtonWrapper>;
};

export default IconButton;
